"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTableOwnership = void 0;
const lodash_1 = __importDefault(require("lodash"));
const athena_utilities_1 = require("@finley-technologies/athena-utilities");
const finley_types_1 = require("@finley-technologies/finley-types");
const { some } = lodash_1.default;
/**
 * Rough check that the datalake tables visited (determined via valid prefix)
 * are in the valid slug list.  This a proxy vs querying athena for actual table names,
 * which would add multiple seconds to very CA WIP save / commit.
 */
const validateTableOwnership = ({ validSlugs, queries, }) => {
    const tables = new Set();
    const errors = [];
    queries.forEach((query) => {
        try {
            // todo - this is less than ideal
            // find an off the self parser for trino / presto
            // to find table names
            const tablesNames = athena_utilities_1.validate.extractTableNamesFromQuery(query);
            const tablesToCheck = tablesNames.filter((table) => some(finley_types_1.DataLake.TablePrefix, (prefix) => !!table.match(new RegExp(`^${prefix}`))));
            tablesToCheck.forEach((table) => {
                tables.add(table.toLowerCase());
            });
        }
        catch (err) {
            errors.push(`Failed to parse query: [${JSON.stringify(query)}]`);
        }
    });
    const lowerSlugs = validSlugs.map((slug) => slug.toLowerCase());
    Array.from(tables).forEach((table) => {
        if (!some(lowerSlugs, (slug) => !!table.match(new RegExp(`${slug}$`)))) {
            errors.push(`Portfolio Covenant Query references table ${table}, but ${table} in not in valid entity list of ${JSON.stringify(validSlugs)}`);
        }
    });
    return errors;
};
exports.validateTableOwnership = validateTableOwnership;
//# sourceMappingURL=tableOwnership.js.map